import m from "../../geodata/es2015/sloveniaHigh";
window.am4geodata_sloveniaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/sloveniaHigh.js
// module id = null
// module chunks = 